<template>
    <CourseListPrivateComponent />
</template>


<script>
import CourseListPrivateComponent from '../../components/courses/course_list_private.vue'

export default {
    data() {
        return {

        }
    },
    methods : {
    },
    components: {
        CourseListPrivateComponent
    }
}
</script>